import React, { useState, useEffect } from 'react';

function Confirmation() {
  const [deliveryEstimate, setDeliveryEstimate] = useState('');

  useEffect(() => {
    setDeliveryEstimate('2-3 days');
  }, []);

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-lg-6">
          <div className="text-center mb-4">
            <div className="mb-4">
              <div className="bg-success rounded-circle d-inline-flex align-items-center justify-content-center text-white mb-3" style={{ width: '80px', height: '80px' }}>
                <i className="bi bi-check-lg fs-2"></i>
              </div>
              <h1 className="display-5 fw-light text-muted">Order Confirmed</h1>
            </div>
            <p className="lead text-muted">Thank you for your order</p>
          </div>
          <div className="card border-0 shadow-sm">
            <div className="card-body p-4 text-center">
              <div className="mb-4">
                <span className="text-muted">Delivery Estimate</span>
                <h3 className="fw-light text-primary">{deliveryEstimate}</h3>
              </div>
              <p className="text-muted">We'll send you updates about your order status.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Confirmation;
